import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { ProjectsSummary } from '../../models/reports';
import { ColorPalette } from '../../styles/constants';
import { generateProjectLabel } from '../../services/projectService';

interface ReportsListProjectItemMobileProps {
  projectSummary: ProjectsSummary;
  setSelectedProject: (projectSummary: ProjectsSummary | null) => void;
}

const styles = {
  paper: {
    p: 0.5,
    marginBottom: 2,
    borderRadius: '5px',
    width: '100%',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
  },
  contentBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '48px',
    padding: '0 16px',
  },
  workedTime: {
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    color: ColorPalette.DARK_GRAY,
    mr: 2,
  },
  workedTimeWarning: {
    fontSize: '14px',
    display: 'inline-flex',
    alignItems: 'center',
    color: ColorPalette.WARNING_RED,
    mr: 2,
  },
  workedTimeFulfilled: {
    display: 'inline-flex',
    alignItems: 'center',
    mr: 2,
  },
};

export function ReportsProjectItemMobile({
  projectSummary,
  setSelectedProject,
}: ReportsListProjectItemMobileProps): JSX.Element {
  const { loggedMDs, project } = projectSummary;

  return (
    <Paper sx={styles.paper} onClick={() => setSelectedProject(projectSummary)}>
      <Box sx={styles.contentBox}>
        <Typography>
          {generateProjectLabel(project.name, project.code)}
        </Typography>
        <Box>
          <Typography>{loggedMDs} MD</Typography>
        </Box>
      </Box>
    </Paper>
  );
}
